/**
 * Created by Julio Perez on 8/3/2017.
 */

// export const emiENV = "PSVA-map-countries-wine-day-2017";
// export const emiENV = "ELND-map-countries-wine-day-2017";
export const emiENV = "ECOM-map-countries-wine-day-2017";

export const isTracking = true;




// WEBPACK FOOTER //
// ./src/app/shared/js/ga-tracking-path.js